import { Footer } from '@scuf/common';
import useUser from 'helpers/hooks/useUser';
import i18n from 'i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CustomFooter: React.FC = () => {
    const { t } = useTranslation(['common']);
    const navigate = useNavigate();
    const width = window.innerWidth;
    const { user } = useUser();
    return (
        <Footer copyrightText="Copyright © 2026 BRADY Worldwide, Inc.">
            <div className="miniContainerFooter">
                <h5>{t('translation.Main')}</h5>
                <a href="#" onClick={() => navigate('/info/repair-center')}>
                    {t('common:services.Repairs')}
                </a>
                <a href="#" onClick={() => navigate('/info/contract')}>
                    {t('pages:Contracts')}
                </a>
                <a href="#" onClick={() => navigate('/info/certified')}>
                    {t('common:services.Certified')}
                </a>
            </div>
            <div className="miniContainerFooter">
                <h5>{t('pages:spareParts')}</h5>
                <a href="#" onClick={() => navigate('/info/spare-parts')}>
                    {t('pages:spareParts')}
                </a>
                <a href="#" onClick={() => navigate('/info/solutions')}>
                    {t('services.Solutions')}
                </a>
            </div>
            <div className="miniContainerFooter">
                <h5>{t('services.Warranty')}</h5>
                <a href="#" onClick={() => navigate('/warranty-consult')}>
                    {t('services.WarrantyConsult')}
                </a>
                <a href="https://automation.honeywell.com/us/en/support/productivity-solutions/warranties/warranty-matrix" target="_blank">{t('services.WarrantyMatrix')}</a>
            </div>
            <div className="miniContainerFooter">
                <h5>{t('translation.Contact')}</h5>
                <a href="#" onClick={() => navigate('/info/contact')}>
                    {t('services.Service')}
                </a>
                <a href="#" onClick={() => navigate('/find-assistance')}>
                    {t('services.FindAssistance')}
                </a>
                {i18n.language == 'pt' ? (
                    <a href="https://www.google.com/maps/d/viewer?mid=1ExIejmI1uCO0joZnOzme9WZ6SziaDgU&ll=-14.31094518110031%2C-58.53285656736145&z=3" target="_blank">{t('services.MapCertifiedPartners')}</a>
                ) : ([])}
            </div>
            <>
                {user == null && (
                    <div className="miniContainerFooter">
                        <h5>{t('services.MyAccount')}</h5>
                        <a href={process.env.REACT_APP_SSO_LOGIN}>{t('actions.SignIn')}</a>
                        <a href={process.env.REACT_APP_SSO_REGISTER} onClick={() => navigate('/login/sign-up')}>
                            {t('actions.SignUp')}
                        </a>
                        <a href={process.env.REACT_APP_SSO_PASSWORD_RECOVER}>{t('actions.ForgotPassword')}</a>
                    </div>
                )}
            </>
            {width > 845 ? (
                <div className="miniContainerFooter">
                    <h5>{t('translation.Address')}</h5>
                    <ul>Rua Oswaldo Cruz, 615 - Bairro Varginha</ul>
                    <ul>Itajubá - MG - Brasil</ul>
                    <ul>CEP: 37501-168</ul>
                    <ul>CNPJ: 00.954.716/0002-09</ul>
                    <ul>IE: 324.996.037.0079</ul>
                </div>
            ) : null}
        </Footer>
    );
};

export default CustomFooter;
